import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styled from 'styled-components'

const LatestManualSkeletonContainer = styled.div`
	padding: 0 20px 20px;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin-bottom: 76px;

	& > h5 {
		font-weight: 700;
		font-size: 20px;
		line-height: 140%;
		color: #333333;
		padding: 0 0 16px;
		border-bottom: 1px solid #ddd9d9;
		margin-bottom: 24px;
	}

	@media (min-width: 768px) {
		align-items: center;
		padding: 0 60px;

		& > h5 {
			width: 100%;
			max-width: 904px;
			text-align: center;
		}
	}
`

const SkeletonContent = styled.div`
	width: 100%;

	@media (min-width: 768px) {
		max-width: 904px;
	}
`

const MetaRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 16px;
	margin-bottom: 12px;

	@media (min-width: 768px) {
		justify-content: center;
		margin: 12px 0 16px;
	}
`

const LatestManualSkeleton = () => {
	return (
		<LatestManualSkeletonContainer>
			<h5>Latest Uploaded Manual</h5>

			<SkeletonContent>
				{/* Header image */}
				<Skeleton height={180} style={{ marginBottom: '16px', borderRadius: '6px' }} />

				{/* Meta details row */}
				<MetaRow>
					<Skeleton width={100} height={16} />
					<Skeleton width={120} height={16} />
				</MetaRow>

				{/* Topic title */}
				<Skeleton width='90%' height={24} style={{ marginBottom: '4px', maxWidth: '350px' }} />
				<Skeleton width='70%' height={24} style={{ marginBottom: '24px', maxWidth: '280px' }} />

				{/* CTA button */}
				<Skeleton width={116} height={28} style={{ marginBottom: '20px' }} />
			</SkeletonContent>
		</LatestManualSkeletonContainer>
	)
}

export default LatestManualSkeleton
